import _ from 'lodash';
import { defaultJson } from './defaultTemplate';
import { AuthContext } from '../../Context/authContext';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import routes from '../Constants/routes';
import { AVAILABLE_QUALIFYING_EXAMS_WITH_INDEX, DOC_ASSIGN_NOMENCLATURE, EDUCATION_TYPES, RECORDTYPE_IDS, REGEX } from '../Constants/constant';

export const getVisibleSteps = (metaData = []) => {
  let steps = [];
  const hasValues = metaData.some((items) => {
    return items;
  });

  if (metaData && hasValues) {
    for (let i = 0; i < metaData.length; i++) {
      const element = metaData[i];
      if (element) {
        steps = [...steps, ...JSON.parse(element)].flat();
      }
    }
    // steps = defaultJson;
  } else {
    steps = defaultJson;
  }

  return steps;
};

export function removeNullKeys(obj) {
  for (let key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      removeNullKeys(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }
  return obj;
}

export const getCurrentStepPayload = function (formValues, applicationData, steps, activeStep) {
  const getUpdatedValue = function (key, formValue, allData) {
    return { ...allData[key], ...formValue };
  };
  const result = {};
  _.keys(formValues).forEach((key) => {
    if (_.isArray()) {
      result[key] = formValues[key].map((el) => getUpdatedValue(key, el, applicationData));
    } else {
      result[key] = getUpdatedValue(key, formValues[key], applicationData);
    }
  });

  return result;
};

export function getDirtyValues(dirtyFields, allValues) {
  return _.pick(allValues, _.keys(dirtyFields));
}

// Map RHF's dirtyFields over the `data` received by `handleSubmit` and return the changed subset of that data.
export function dirtyValues(dirtyFields, allValues) {
  // If *any* item in an array was modified, the entire array must be submitted, because there's no way to indicate
  // "placeholders" for unchanged elements. `dirtyFields` is `true` for leaves.
  if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues;
  // Here, we have an object
  return Object.fromEntries(Object.keys(dirtyFields).map((key) => [key, dirtyValues(dirtyFields[key], allValues[key])]));
}

function removeFalseKeys(obj) {
  const t = _(obj)
    .pickBy(_.isBoolean)
    .omitBy((o) => {
      return !o;
    })
    .value();

  const t1 = _(obj).omitBy(_.isBoolean).value();
  return { ...t, ...t1 };
}

function removeEmptyObjects(obj) {
  const oo = removeFalseKeys(obj);

  return (
    _(oo)
      .pickBy(_.isObject)
      // .omitBy(_.isArray)
      .mapValues(removeEmptyObjects)
      .omitBy(_.isEmpty)
      .omitBy((o) => {
        const isValid =
          Object.keys(o).filter((key) => {
            return o[key];
          }).length === 0;

        return isValid;
      })
      .assign(_.omitBy(oo, _.isObject))
      .value()
  );
}

export function addExtrasFieldsToObject(obj, extraFields) {
  const objectVals = addObjectExtras(obj, extraFields);
  // const arrayVals = addArrayExtras(obj, extraFields);
  // console.log(arrayVals);

  return objectVals;
}

function addObjectExtras(obj, extraFields) {
  return _(obj)
    .pickBy(_.isObject)
    .mapValues((e) => {
      console.log('==>: ', e, _.isArray(e), _.isObject(e));
      if (_.isArray(e)) {
        return _.map(e, (a) => addObjectExtras(_.extend({}, a, extraFields), extraFields));
      }
      if (_.isObject(e)) {
        return addObjectExtras(_.extend({}, e, extraFields), extraFields);
      }
      return _.extend({}, e, extraFields);
    })
    .assign(_.omitBy(obj, _.isObject))
    .value();
}

function addArrayExtras(obj, extraFields) {
  console.log('Array obj: ', obj);

  return _(obj)
    .pickBy(_.isArray)
    .mapValues((e) => {
      if (_.isObject(e)) {
        return addObjectExtras(e, extraFields);
      }
      return addArrayExtras(e, extraFields);
    })
    .mapValues(_.values)
    .assign(_.omitBy(obj, _.isArray))
    .value();
}

export function removeArrayItem(obj, name, index) {
  _.unset(obj, `${name}[${index}]`);
  _.set(
    obj,
    name,
    _.get(obj, name)?.filter((e) => e)
  );
  return obj;
}

export function filterDirtyFields(dirtyFields) {
  const onlyObjs = removeEmptyObjects(dirtyFields);
  // const arraysRemoved = removeEmptyArrays(dirtyFields);
  // console.log("Onlyobjs: ", arraysRemoved);

  return { ...onlyObjs };
}

export function applicationAddCurrentStep(payloadApplication, { application = {} }, activeStep, next = false) {
  let stepVal = null;
  stepVal = { Current_Step__c: next === true ? activeStep + 1 : activeStep };
  return stepVal ? { application: { ...(payloadApplication || application), ...stepVal } } : {};
}

export const PrivateRouter = ({ children }) => {
  const {
    state: { isAuthenticated },
  } = useContext(AuthContext);

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to={routes.login} />;
};

export const PublicRouter = ({ children }) => {
  const {
    state: { isAuthenticated, search },
  } = useContext(AuthContext);

  if (!isAuthenticated) {
    return children;
  }

  if (search !== null && search !== '' && search !== undefined) {
    return <Navigate to={`/courses?search=${search}`} />;
  }

  return <Navigate to={routes.home} />;
};

export const getSplitName = (combinedName, key, returnArray = false) => {
  const obj = {
    objectName: '',
    fieldName: '',
  };
  const replaceBrackets = combinedName.replace(/[\[\]']+/g, ' ')?.trim();
  const splitStr = replaceBrackets?.split(' ');
  if (Array.isArray(splitStr) && splitStr.length > 0) {
    obj.objectName = splitStr[0];
    obj.fieldName = splitStr[1];
  }
  if (key === 'objectName') return obj.objectName;
  if (key === 'fieldName') return obj.fieldName;
  if (returnArray) return splitStr;
  return obj;
};

export const returnFirstElement = (arr, firstElement) => {
  const getElement = arr?.find((items) => {
    return items.value === firstElement;
  });
  let customArr = [...arr].filter((items) => {
    return items.value !== firstElement;
  });

  return [getElement, ...customArr];
};

export const shrinkTextBased = (limit = 0, text = '') => {
  return text.length > limit ? `${text.substring(0, limit)}...` : text;
};

export const handleError = (enqueueSnackbar, error) => {
  if (!error?.response?.data?.success) {
    enqueueSnackbar(error?.response?.data?.errorMessage || 'Something went wrong', { variant: 'error' });
  } else {
    enqueueSnackbar(error?.message || 'Something went wrong', {
      variant: 'error',
    });
  }
};

export const getFieldTypeFromSteps = (arr, name) => {
  return (arr || [])?.find((items) => {
    return (items?.sections || [])?.find((subItems) => {
      return (subItems?.fields || [])?.find((fields) => {
        return fields?.name === name;
      });
    });
  });
};

export function bytesToMB(bytes) {
  return (bytes / (1024 * 1024)).toFixed(2);
}

export const customizeArrayFields = (mainSchema, name, index) => {
  let schema = { ...mainSchema };

  // Destructuring Field Data for fieldSchemaValidation
  if (schema?.validateField) {
    let fieldSchemaName = { ...schema?.validateField, scope: schema?.validateField?.strictComparison ? schema?.validateField.scope : `${name}.${index}.${schema?.validateField.scope}` };
    schema.validateField = fieldSchemaName;
  }
  //Destructuring the name if any rule is applied to the field
  if (schema?.rule) {
    let scopeName = schema.rule.condition.scope;
    let scopeValue = schema.rule.condition.expectedValue;

    if (typeof scopeValue !== 'string') {
      let newObjectValues = {};
      const expectedValueObj = schema.rule.condition.expectedValue;
      const expectedValueArray = Object.keys(expectedValueObj);
      for (let i = 0; i < expectedValueArray.length; i++) {
        const element = expectedValueArray[i];
        newObjectValues[`${name}.${index}.${element}`] = expectedValueObj[element];
      }

      schema.rule.condition.expectedValue = newObjectValues;
    }

    if (typeof scopeName === 'string') {
      schema.rule.condition.scope = `${name}.${index}.${scopeName}`;
    } else {
      schema.rule.condition.scope = schema.rule.condition.scope?.map((items) => {
        return `${name}.${index}.${items}`;
      });
    }
  }

  // For Formula Schema
  if (schema?.formulas) {
    const newArrayFields = schema?.formulas?.scopeFields;
    let newObj = {};
    Object.keys(newArrayFields).forEach((items) => {
      newObj[items] = `${name}.${index}.${newArrayFields[items]}`;
    });
    schema['formulas']['scopeFields'] = newObj;
  }

  // For Mindate/Maxdate Schema
  if (typeof schema?.minDate === 'object') {
    schema['minDate']['scope'] = schema?.minDate?.constant ? schema?.minDate?.scope : `${name}.${index}.${schema['minDate']['scope']}`;
    if (typeof schema['minDate']?.add?.value === 'object') {
      schema['minDate']['add']['value']['scope'] = `${name}.${index}.${schema?.minDate?.add?.value?.scope}`;
    }
  }
  if (typeof schema?.maxDate === 'object') {
    schema['maxDate']['scope'] = schema?.maxDate?.constant ? schema?.maxDate?.scope : `${name}.${index}.${schema['maxDate']['scope']}`;
  }

  if (schema?.metaData?.valueKey) {
    schema['metaData']['valueKey'] = `${name}.${index}.${schema['metaData']['valueKey']}`;
  }

  return schema;
};

export function parseFieldKey(key) {
  const regex = REGEX.ARRAYFIELDNAME;
  const match = key.match(regex);

  if (match) {
    const [, base, index, field] = match;
    return { base, index, field };
  } else {
    return null;
  }
}

export const modifyPayload = (mainData, applicationState, recordsTypes) => {
  let data = { ...mainData };

  if (
    data?.data?.application?.Applicant_Type__c === 'Domestic' ||
    (data?.data?.application?.Applicant_Type__c === 'International' && data?.data?.application?.Category__c === 'Overseas Candidate (holding Indian Passport) (OS-CND)')
  ) {
    data.data['application']['hed__Citizenship__c'] = data?.data?.application?.hed__Citizenship__c ? data?.data?.application?.hed__Citizenship__c : 'Indian';
  }

  if (data?.data?.application?.Applicant_Type__c === 'International') {
    data.data['application']['Eligibility_Test_Intr__c'] = data?.data?.application?.Eligibility_Test__c;
  }

  // Ref: IIMU-JIRA-234
  if (data?.data?.application?.Eligibility_Test__c) {
    if (data?.data?.application?.Eligibility_Test__c === 'GMAT') {
      if (data?.data?.application?.Applicant_Type__c === 'International') {
        data.data['application']['GMAT_Total_Score_Intr'] = data?.data?.application?.GMAT_GRE_total_score_CAT_Percentile__c;
      } else {
        data.data['application']['GMAT_Total_Score'] = data?.data?.application?.GMAT_GRE_total_score_CAT_Percentile__c;
      }
    } else if (data?.data?.application?.Eligibility_Test__c === 'CAT') {
      data.data['application']['CAT_Total_Score'] = data?.data?.application?.GMAT_GRE_total_score_CAT_Percentile__c;
    } else if (data?.data?.application?.Eligibility_Test__c === 'GRE') {
      if (data?.data?.application?.Applicant_Type__c === 'International') {
        data.data['application']['GRE_Total_Score_Intr'] = data?.data?.application?.GMAT_GRE_total_score_CAT_Percentile__c;
      } else {
        data.data['application']['GRE_Total_Score'] = data?.data?.application?.GMAT_GRE_total_score_CAT_Percentile__c;
      }
    } else if (data?.data?.application?.Eligibility_Test__c === 'GMAT Focus') {
      if (data?.data?.application?.Applicant_Type__c === 'International') {
        data.data['application']['GMAT_Focus_Total_Score_Intr'] = data?.data?.application?.GMAT_GRE_total_score_CAT_Percentile__c;
      } else {
        data.data['application']['GMAT_Focus_Total_Score'] = data?.data?.application?.GMAT_GRE_total_score_CAT_Percentile__c;
      }
    } else {
      //....
    }
  }

  if (data?.data?.application?.Applicant_Type__c === 'International') {
    delete data.data['application']['Eligibility_Test__c'];
  }

  if ((data.data?.addresses || [])?.length === 0) {
    if (data.data.hasOwnProperty('addresses')) {
      data.data['addresses'].push({
        Is_permanent_address_same_as_current_add__c: 'true',
      });
    } else {
      data.data['addresses'] = [
        {
          Is_permanent_address_same_as_current_add__c: 'true',
        },
      ];
    }
  }

  const newExamination = [];
  for (let i = 0; i < AVAILABLE_QUALIFYING_EXAMS_WITH_INDEX.length; i++) {
    const course = AVAILABLE_QUALIFYING_EXAMS_WITH_INDEX[i];
    const entranceData = data.data.examinations?.find((item) => {
      return item?.Exam_Name__c === course;
    });

    newExamination.push({ ...entranceData, Exam_Name__c: course });
  }
  data.data.examinations = newExamination;

  let newEducationHistories;

  if (data?.data?.educationHistories) {
    newEducationHistories = {
      educationHistoriesUg: (data?.data?.educationHistories || [])
        ?.filter((items) => {
          return items?.Degree_Type__c === EDUCATION_TYPES['educationHistoriesUg'];
        })
        .map((items) => {
          const duration = items?.Duration_of_the_Program__c ? parseInt(items.Duration_of_the_Program__c.split(' ')[0], 10) || null : null;
          return {
            ...items,
            Duration_of_the_Program__c: duration,
          };
        }),
      educationHistoriesOthers: (data?.data?.educationHistories || [])
        ?.filter((items) => {
          return (
            items?.Degree_Type__c !== EDUCATION_TYPES['educationHistoriesUg'] &&
            items?.Degree_Type__c !== EDUCATION_TYPES['educationHistories[0]'] &&
            items?.Degree_Type__c !== EDUCATION_TYPES['educationHistories[1]']
          );
        })
        .map((items) => {
          const duration = items?.Duration_of_the_Program__c ? parseInt(items.Duration_of_the_Program__c.split(' ')[0], 10) || null : null;
          return {
            ...items,
            Duration_of_the_Program__c: duration,
          };
        }),
      educationHistoriesPhd: (data?.data?.educationHistories || [])
        .map((items) => {
          const duration = items?.Duration_of_the_Program__c ? parseInt(items.Duration_of_the_Program__c.split(' ')[0], 10) || null : null;
          return {
            ...items,
            Duration_of_the_Program__c: duration,
          };
        })
        .filter((items) => {
          return items?.Degree_Type__c !== EDUCATION_TYPES['educationHistories[0]'] && items?.Degree_Type__c !== EDUCATION_TYPES['educationHistories[1]'];
        }),
      educationHistories: (data?.data?.educationHistories || [])?.filter((items) => {
        return items?.Degree_Type__c === EDUCATION_TYPES['educationHistories[0]'] || items?.Degree_Type__c === EDUCATION_TYPES['educationHistories[1]'];
      }),
    };
    delete data.data['educationHistories'];
  }

  const customRecords = { ...data.data };
  const employmentrecordIds = recordsTypes?.['workExperiences'] ? recordsTypes['workExperiences'] : applicationState?.recordTypeIds?.['workExperiences'];
  Object.keys(RECORDTYPE_IDS['workExperiences']).forEach((items) => {
    if (customRecords?.workExperiences || [].length > 0) {
      const newData =
        customRecords?.workExperiences?.filter((subitems) => {
          return subitems?.RecordTypeId === employmentrecordIds[RECORDTYPE_IDS['workExperiences'][items]];
        }) || [];
      data.data[`${items}`] = newData;
    }
  });

  let newDocumentChecklist = {};
  const documentChecklist = data?.data?.documentChecklists || [];
  for (let i = 0; i < documentChecklist.length; i++) {
    const element = documentChecklist[i];
    if (DOC_ASSIGN_NOMENCLATURE[element?.Criteria_Object__c]) {
      if (newDocumentChecklist.hasOwnProperty(DOC_ASSIGN_NOMENCLATURE[element?.Criteria_Object__c])) {
        newDocumentChecklist[DOC_ASSIGN_NOMENCLATURE[element?.Criteria_Object__c]].push(element);
      } else {
        newDocumentChecklist[DOC_ASSIGN_NOMENCLATURE[element?.Criteria_Object__c]] = [element];
      }
    } else {
      if (newDocumentChecklist.hasOwnProperty('Others')) {
        newDocumentChecklist['Others'].push(element);
      } else {
        newDocumentChecklist['Others'] = [element];
      }
    }
  }

  return {
    ...data.data,
    ...newEducationHistories,
    documentChecklists: newDocumentChecklist,
    originalDocumentChecklists: data?.data?.documentChecklists,
    form: { endDate: applicationState?.form?.endDate },
  };
};

export const triggerFieldError = (errors) => {
  const errorFields = [];
  for (const i in errors) {
    const value = errors[i];
    if (Array.isArray(value)) {
      for (const k in value) {
        for (const z in value[k]) {
          errorFields.push(`${i}.${k}.${z}`);
        }
      }
    } else {
      for (const z in value) {
        errorFields.push(`${i}[${z}]`);
      }
    }
  }

  return errorFields;
};

export function getValueByFieldName(data, fieldName) {
  if (!fieldName) return undefined;

  const path = fieldName.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '');

  const keys = path.split('.');

  return keys.reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : undefined), data);
}

export function splitFieldPath(field) {
  const regex = /([^[.\]]+)|\[(.*?)\]/g;
  const result = [];
  let match;

  while ((match = regex.exec(field))) {
    result.push(match[1] || match[2]);
  }

  return result;
}

export function downloadFile(pdfUrl, fileName = 'download.pdf') {
  fetch(pdfUrl)
    .then((response) => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error('Download failed:', error);
    });
}

export function downloadBase64File(base64Data, fileName, mimeType = 'application/pdf') {
  const linkSource = `data:${mimeType};base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

export function findMimeType(type) {
  switch (type) {
    case 'WORD_X':
      return 'application/msword';
    // Add the types here...
    default:
      return 'application/pdf';
  }
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const findDupes = (data) => {
  for (let i = 0; i < data.length; i++) {
    const element = data[i];
    const findDupes = data.find((sub, index) => {
      return index !== i && sub?.Degree_Name__c === element?.Degree_Name__c && sub?.Discipline__c === element?.Discipline__c;
    });
    if (findDupes) {
      return true;
    }
  }

  return false;
};

export const getScopeFields = (array, name) => {
  let customName = name;
  let selectedField;

  if (/\.\d+\./.test(name)) {
    customName = name.replace(/(\w+)\.(\d+)\.(\w+)/, (match, obj, index, field) => `${obj}[${index}][${field}]`);
  }

  for (let i = 0; i < array.length; i++) {
    const sections = array[i]?.sections || [];
    for (let j = 0; j < sections.length; j++) {
      const fields = sections[j]?.fields || [];
      for (let k = 0; k < fields.length; k++) {
        const field = fields[k];
        if (field?.type === 'array') {
          const fieldArray = field?.fieldsArray || [];
          for (let l = 0; l < fieldArray.length; l++) {
            const arrayField = fieldArray[l];
            if (arrayField?.name === customName) {
              selectedField = arrayField;
            }
          }
        } else {
          if (field?.name === customName) {
            selectedField = field;
          }
        }
      }
    }
  }

  return selectedField;
};
